import { render, staticRenderFns } from "./PastGameDetails.vue?vue&type=template&id=6c781719&scoped=true"
import script from "./PastGameDetails.vue?vue&type=script&lang=js"
export * from "./PastGameDetails.vue?vue&type=script&lang=js"
import style0 from "./PastGameDetails.vue?vue&type=style&index=0&id=6c781719&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c781719",
  null
  
)

export default component.exports